import { render, staticRenderFns } from "./CRMCreatePostbackConfiguration.vue?vue&type=template&id=2beee136&scoped=true"
import script from "./CRMCreatePostbackConfiguration.vue?vue&type=script&lang=js"
export * from "./CRMCreatePostbackConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beee136",
  null
  
)

export default component.exports